import { walletUrl } from '../services/config';
import { isWalletFeatureEnabled } from '@/constants/wallet';
import { useQueryClient } from '@tanstack/react-query';
import { E_WALLET } from '../services/types';

export const useInvalidateWallet = () => {
  const queryClient = useQueryClient();

  const invalidateBalance = () => {
    isWalletFeatureEnabled &&
      queryClient.invalidateQueries([
        {
          method: 'get',
          url: `${walletUrl}/balance`,
        },
      ]);
  };

  const invalidateTransactions = () => {
    isWalletFeatureEnabled &&
      queryClient.invalidateQueries([
        {
          method: 'get',
          url: walletUrl,
          params: {
            page: 1,
            limit: 10,
          },
        },
      ]);
  };

  const invalidateExpiredTransactions = () => {
    isWalletFeatureEnabled &&
      queryClient.invalidateQueries([
        {
          method: 'get',
          url: `${walletUrl}/expired`,
          params: {
            page: 1,
            limit: 10,
            walletType: E_WALLET,
          },
        },
      ]);
  };

  const invalidateAllWallet = () => {
    invalidateBalance();
    invalidateTransactions();
    invalidateExpiredTransactions();
  };

  return {
    invalidateBalance,
    invalidateTransactions,
    invalidateExpiredTransactions,
    invalidateAllWallet,
  };
};
